import { render, staticRenderFns } from "./sensibilityTextAdd.vue?vue&type=template&id=608524b6&scoped=true"
import script from "./sensibilityTextAdd.vue?vue&type=script&lang=js"
export * from "./sensibilityTextAdd.vue?vue&type=script&lang=js"
import style0 from "./sensibilityTextAdd.vue?vue&type=style&index=0&id=608524b6&prod&lang=scss&scoped=true"
import style1 from "./sensibilityTextAdd.vue?vue&type=style&index=1&id=608524b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608524b6",
  null
  
)

export default component.exports